<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="购房线索">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id" @created="initData"  :clueId=1  :owned="true" :init-choose-first="false" :dataType=1 ref="siteAutoComplete"></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition" v-if="condition.site_id!=0">
                            <span class="label">区域</span>
                            <div class="input-condition">
                                <site-area-cascader  v-model="condition.area_id" :site-id="condition.site_id" :emit-path="false" clearable></site-area-cascader>
                            </div>
                        </div>
                        <div class="search-condition" v-if="condition.site_id!=0">
                            <span class="label">楼盘</span>
                            <div class="input-condition">
                                <house-auto-complete v-model="condition.house_id" :site-id="condition.site_id" clearable></house-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">电话</span>
                            <div class="input-condition">
                                <el-input v-model="condition.client_mobile" placeholder="请输入电话"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">报名时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.date"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        :picker-options="pickerOptions"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来源方式</span>
                            <div class="input-condition">
                                <el-select v-model="condition.source_id" placeholder="请选择">
                                    <el-option v-for="item in sources" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来源终端</span>
                            <div class="input-condition">
                                <el-select v-model="condition.terminal_id" placeholder="请选择">
                                    <el-option v-for="item in terminals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来源渠道</span>
                            <div class="input-condition">
                                <el-select v-model="condition.channel_id" placeholder="请选择">
                                    <el-option v-for="item in channels" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">线索状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.is_blacklist" placeholder="请选择">
                                    <el-option v-for="item in threadStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">表单校验状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.sms_check" placeholder="请选择">
                                    <el-option v-for="item in smsCheckList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="导出" placement="top">
                            <el-button icon="el-icon-download" @click="download"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <el-table-column  label="站点" prop="site_name" width="120px"></el-table-column>
                    <el-table-column  label="区域" prop="area_name_str"></el-table-column>
                    <el-table-column  label="电话" prop="client_mobile" width="120px"></el-table-column>
                    <el-table-column  label="楼盘名" prop="house_name_str"></el-table-column>
                    <el-table-column  label="来源方式" prop="source_name" width="80px"></el-table-column>
                    <el-table-column  label="页面位置" prop="page_str"></el-table-column>
                    <el-table-column  label="来源终端" prop="terminal_name" width="80px"></el-table-column>
                    <el-table-column  label="来源渠道" prop="channel_name"></el-table-column>
                    <el-table-column  label="线索状态" prop="is_blacklist">
                        <template slot-scope="scope">
                            <span>{{scope.row.is_blacklist == "0" ? "正常":"黑名单"}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px"  label="表单校验状态" prop="sms_check">
                        <template slot-scope="scope">
                            <span>{{scope.row.sms_check == "0" ? "":scope.row.sms_check == "1"?"未校验":"已校验"}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  label="报名时间" prop="created_at"></el-table-column>
                    <el-table-column  label="操作" width="100px"  fixed="right">
                        <template slot-scope="scope">
                                <el-button size="mini" @click="openDetail(scope.$index, scope.row)" v-permission="'data.customers.detail'"
                                >查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
                <detail ref="detail" @add_black="handleAdd"/>
                <add-user-black ref="backAddRef" :callback="initData" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { getCustomers,getTerminals,getSources,getFormChannels  } from '@/service/customer'
    import { parseTime } from '@/utils'
    import {getUser} from '@/utils/auth'
    import { getSite, getSiteAreas } from '@/service/site'
    import DynamicSelect from '@/components/dynamicSelect'
    import {housesAutoComplete} from '@/service/housedict'
    import detail from './componenet/detail'
    import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
    import { getSitesAutoComplete } from '@/service/site'
    import SiteAreaCascader from "../../../components/auto-complete/site-area-cascader";
    import HouseAutoComplete from "../../../components/auto-complete/house-auto-complete";
    import addUserBlack from './componenet/addUserBlack';
    export default {
        name: "List",
        components: {
            HouseAutoComplete,
            SiteAreaCascader,
            SiteAutoComplete,
            DynamicSelect,
            detail,
            addUserBlack
        },
        data () {
            return {
                condition : {
                    page :1,
                    per_page : 10,
                    total : 0,
                    site_id : null,
                    source_id : 0,
                    channel_id : 0,
                    terminal_id : 0,
                    area_id : 0,
                    is_blacklist:"0",
                    house_id: '',
                    house_name : '',
                    client_mobile: '',
                    date : [],
                    sms_check:"0",
                },
                sources : [
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                terminals : [
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                channels : [
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                threadStatus:[
                    {
                        id : "2",
                        name : '全部'
                    },
                    {
                        id : "0",
                        name : '正常'
                    },{
                        id : "1",
                        name : '黑名单'
                    }
                ],
                smsCheckList:[
                    {
                        id : "0",
                        name : '全部'
                    },
                    {
                        id : "1",
                        name : '未校验'
                    },{
                        id : "2",
                        name : '已校验'
                    }
                ],
                list: [],
                isLoading: true,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                isShowMore: false,
                siteAll:[],
            }
        },
        computed: {
            // getSiteId () {
            //     return this.condition.site_id
            // }
        },
        mounted () {
            this.getSources()
            this.getTerminals()
            this.getChannels()
            this.getSiteList()
        },
        methods: {
            async getSiteList() {
                await getSite({ owned:1, agent_status: 0, per_page: 1000 }).then((data) => {
                    this.siteAll = data.data;
                });
              
            },
            handleAdd(data){
                this.$refs.backAddRef && 
                (this.$refs.backAddRef.siteList = this.siteAll)
                this.$refs.backAddRef.openMenu(data)
            },
            openDetail(index, row){
                this.$refs.detail
                && ( Object.assign(this.$refs.detail.info, row))
                && this.$refs.detail.open()
            },
            resetSearch(){
                this.condition = {
                    page :1,
                    per_page : 10,
                    total : 0,
                    site_id : '',
                    source_id : 0,
                    channel_id : 0,
                    terminal_id : 0,
                    is_blacklist:"",
                    area_id : '',
                    house_id : '',
                    house_name : '',
                    client_mobile:'',
                    date : [],
                }
                // this.initData()
                this.$nextTick(() => {
                    this.$refs.siteAutoComplete && this.$refs.siteAutoComplete.reset();
                })
            },
            getSources(){
                getSources({}).then((data) => {
                    this.sources = this.sources.concat(data)
                })
            },
            getTerminals(){
                getTerminals({}).then((data) => {
                    this.terminals = this.terminals.concat(data)
                })
            },
            getChannels(){
                getFormChannels({}).then((data) => {
                    this.channels = this.channels.concat(data)
                })
            },
            handleSearch() {
                this.condition.page = 1
                this.initData()
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = []
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                let query = Object.assign({}, {}, this.condition)
                if (this.condition.date.length > 0) {
                    query.start_time = new Date(this.condition.date[0]).getTime()/1000
                    query.end_time = new Date(this.condition.date[1]).getTime()/1000
                }
                await getCustomers(query).then((data) => {
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        row.area_name_str = ''
                        row.house_name_str = ''
                        row.page_str = ''
                        if (row.area_arr && row.area_arr.length > 0) {
                            let area = []
                            for (let j in row.area_arr) {
                                area.push(row.area_arr[j].area_name)
                            }
                            row.area_name_str = area.join('-')
                        }
                        if (row.house_arr && row.house_arr.length > 0) {
                            let house = []
                            for (let j in row.house_arr) {
                                house.push(row.house_arr[j].house_name)
                            }
                            row.house_name_str = house.join('-')
                        }
                        if (row.form_page.length > 0 && row.form_name.length > 0) {
                            row.page_str = row.form_page + '-' + row.form_name
                        } else {
                            row.page_str = row.form_page + row.form_name
                        }
                        row.created_at = parseTime(new Date(row.created_at))
                    }
                    this.list = listData
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            async download () {
                if (this.condition.date.length == 0) {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                import('@/vendor/Export2Excel').then(async excel => {
                    const tHeader = ['站点','区域','电话','楼盘名','来源方式','页面位置','来源终端','来源渠道','线索状态','报名时间','IP','其他信息']
                    const filterVal = ['site_name','area_name_str', 'client_mobile', 'house_name_str', 'source_name','page_str','terminal_name','channel_name','is_blacklist','created_at','ip', 'extra']
                    let list = []
                    let query = {
                        export : 1,
                        page : 1,
                        per_page : 999,
                        site_id : this.condition.site_id,
                        source_id : this.condition.source_id,
                        channel_id : this.condition.channel_id,
                        terminal_id : this.condition.terminal_id,
                        is_blacklist:this.condition.is_blacklist,
                        area_id : this.condition.area_id,
                        house_id : this.condition.house_id,
                        house_name : this.condition.house_name,
                        client_mobile : this.condition.client_mobile
                    }
                    if (this.condition.date.length > 0) {
                        query.start_time = new Date(this.condition.date[0]).getTime()/1000
                        query.end_time = new Date(this.condition.date[1]).getTime()/1000
                    }
                    this.isLoading = true
                    // 模拟fetch请求数据....
                    await getCustomers(query).then((data) => {
                        let listData = data.data
                        for (let i in listData) {
                            let row = listData[i]
                            row.area_name_str = ''
                            row.house_name_str = ''
                            row.page_str = ''
                            row.extra = ''
                            if (row.area_arr && row.area_arr.length > 0) {
                                let area = []
                                for (let j in row.area_arr) {
                                    area.push(row.area_arr[j].area_name)
                                }
                                row.area_name_str = area.join('-')
                            }
                            if (row.house_arr && row.house_arr.length > 0) {
                                let house = []
                                for (let j in row.house_arr) {
                                    house.push(row.house_arr[j].house_name)
                                }
                                row.house_name_str = house.join('-')
                            }
                            if (row.form_page.length > 0 && row.form_name.length > 0) {
                                row.page_str = row.form_page + '-' + row.form_name
                            } else {
                                row.page_str = row.form_page + row.form_name
                            }
                            row.extra = `URL:${row.source_url}\n备注:${row.remark}\n客户意向最低价格:${row.price_min}\n客户意向最高价格:${row.price_max}\n${this.getExtraData(row.extra_json_arr)}`
                            row.created_at = parseTime(new Date(row.created_at))
                        }
                        list = listData.map(item => {
                            item.is_blacklist = item.is_blacklist == "0" ? "正常":"黑名单"
                            return item;
                        })
                    })
                    const formatJson = (filterVal) => {
                        return list.map(v => filterVal.map(j => {
                            return v[j]
                        }))
                    }
                    let name = '线索客户'
                    if (this.condition.date.length > 0) {
                        name += parseTime( new Date(this.condition.date[0]), '{y}-{m}-{d}') + '至' + parseTime( new Date(this.condition.date[1]), '{y}-{m}-{d}')
                    }
                    const data = formatJson(filterVal)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: name
                    })
                    this.isLoading = false
                })
            },
            getExtraData (data) {
                if (data.length <= 0) return ''
                for (let i in data) {
                     return data[i].key + ":" + data[i].value + "\n"
                }
                // if (data.length <= 0) return ''
                // const extra = JSON.parse(data);
                // var arr = Object.keys(extra);
                // if (arr.length <= 0) return ''
                // let extraInfo='';
                // for(let i in extra){
                //     extraInfo+= i + ':' + extra[i]+"\n"
                // }
                // return extraInfo
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },
        }
    }
</script>
<style scoped lang="less">
</style>